module.exports = __webpack_public_path__ + "img/bg-login-s3.1d61705e.png";